import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConnectionService } from '@services/connection-service';
import { Router } from '@angular/router';
import { CsIconModule } from '@components/icon';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

const MAX_INCOMPLETE_PERCENTAGE = 99;

@Component({
  selector: 'app-aov-banner',
  imports: [CommonModule, CsIconModule, LottieComponent],
  templateUrl: './app-aov-banner.html',
  standalone: true
})
export class AovBannerComponent implements OnChanges {
  @Input() amountRemaining: number = 0;
  @Input() freeProductBannerImage: string = '';
  @Input() percentageDone: number = 0;
  @Input() shouldShowConfetti: boolean = false;
  @Input() isEnglishLanguage: boolean = true;
  @Input() displayWhenAmountRemainingIsZero: boolean = false;
  @Input() displayInCartPage?: boolean = false;

  /** Plays once per threshold crossing; `complete` retires it so it does not replay on every render. */
  readonly confettiOptions: AnimationOptions = {
    path: '/assets/animation.json',
    loop: false,
  };
  private confettiPlayed: boolean = false;

  constructor(
    private readonly conn: ConnectionService,
    private readonly router: Router,
  ) {}

  /** A rounded percentage must not unlock the gift while the remaining amount is positive. */
  get isAovComplete(): boolean {
    return this.amountRemaining <= 0 && this.percentageDone >= 100;
  }

  get progressBarWidth(): number {
    return this.isAovComplete ? 100 : Math.min(this.percentageDone, MAX_INCOMPLETE_PERCENTAGE);
  }

  get showConfetti(): boolean {
    return this.shouldShowConfetti && !this.confettiPlayed;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.shouldShowConfetti && !this.shouldShowConfetti) {
      this.confettiPlayed = false;
    }
  }

  onConfettiComplete(): void {
    this.confettiPlayed = true;
  }

  aovBannerClickHandler(): void {
    if (!this.router.url.includes('/cart')) {
      this.conn.navigateToURL('/cart');
    } else {
      this.conn.navigateToURL('/user/order/reorder?showAll=true');
    }
  }
}
